import { WppButton, WppTypography } from '@wppopen/components-library-react'
import styles from './NotFound404Page.module.scss'
import { Link } from 'react-router-dom'
import NotFound404Svg from './NotFound404Svg'

const NotFound404Page = () => {
  return (
    <div className={styles.page} data-testid="not-found-404-page">
      <NotFound404Svg />
      <WppTypography tag="h1" type="5xl-display" className={styles.heading}>
        PAGE NOT FOUND
      </WppTypography>
      <WppTypography tag="h1" type="s-body" className={styles.text}>
        The page you are looking for might have been removed, had it’s name changed or is temporarily unavailable.
      </WppTypography>
      <Link to="/">
        <WppButton size="m" variant="primary">
          Go to homepage
        </WppButton>
      </Link>
    </div>
  )
}

export default NotFound404Page
